import React from 'react';
import moment from 'moment';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { onFormatPaymentStatus } from '../../../../utils/constants/format-order-statuses';
import TableNext from '../../../../shared/table/next-table';

const tableColumns = ['ID', 'Amount', 'Amount Captured', 'Amount Refunded', 'Description', 'Type', 'Status', 'Date']
const tableKeys = ['id', 'amount', 'amountCaptured', 'amountRefunded', 'paymentIntentId', 'type', 'status', 'createdAt']

interface ISellerPaymentsTable {
    rows: any;
    paginationData?: IPage;
    cashoutsLoading: boolean;
    accessControl?: any;
    actions?: any;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const SellerPaymentsTable = ({
    rows,
    paginationData,
    cashoutsLoading,
    setPaginationState,
}: ISellerPaymentsTable) => {
    return (
        <TableNext
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}>
            {cashoutsLoading ?
                <>
                    {[...Array(10)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {tableColumns?.map(element => {
                                    return (
                                        <td key={element} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                {tableKeys?.length > 0 && tableKeys?.map((key, index) => {
                                    let value = row?.[key]
                                    let item = null
                                    if (key === 'createdAt') {
                                        value = moment(row?.createdAt).format('DD-MM-YYYY, HH:mm')
                                    }
                                    if (key === 'amount') {
                                        value = Number(row?.amount || 0).toFixed(2)
                                        item = `${(row?.currency || '')}${value}`
                                    }
                                    if (key === 'amountCaptured') {
                                        value = Number(row?.amountCaptured || 0).toFixed(2)
                                        item = `${(row?.currency || '')}${value}`
                                    }
                                    if (key === 'amountRefunded') {
                                        value = Number(row?.amountRefunded || 0).toFixed(2)
                                        item = `${(row?.currency || '')}${value}`
                                    }
                                    if (key === 'status') {
                                        value = onFormatPaymentStatus(row?.[key])?.name
                                        const color = onFormatPaymentStatus(row?.[key])?.color
                                        item = color && <div className={`${color} flex flex-row justify-center text-center text-red px-1 min-w-[150px] text-black text-sm py-1 font-medium rounded-2xl`}>{value}</div>
                                    }
                                    return (
                                        <td
                                            key={index}
                                            className={key === 'createdAt' ? 'min-w-[140px] px-6 py-4' : 'px-6 py-4'}>
                                            {item || value}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
            }
        </TableNext>
    )
}

export default SellerPaymentsTable;